// The seven top-level routes App.js frames with CierresAppShell — the Cierres redesign's own
// shell, reached only by a `clientType === "CONCILIACION"` business. The list is written out
// rather than derived, because App.js declares each <Route> literally and the thing that needs
// the list runs during App's own render, before any route has matched. A source assertion in
// __tests__/cierresRoutes.test.js pins it against App.js so the two cannot drift apart.
//
// What reads it today is the legacy floating notification bell. `.notification-bell` is
// `position: fixed; top: 20px; right: 30px; z-index: 1000`, which is the same band the Cierres
// header puts the profile initials in, so it painted on top of the avatar and took its clicks.
// Every other shell in the app has no top bar, which is why the bell is only switched off here
// and not moved.
export const CIERRES_PATHS = [
  "/business/backoffice/panel-cierres",
  "/business/backoffice/oficinas",
  "/business/backoffice/alertas",
  "/business/backoffice/chat",
  "/business/backoffice/calendario",
  "/business/backoffice/reportes",
  // Not "/business/backoffice/users" — that one is BusinessBackoffice's own screen and keeps
  // the bell. This is the same component framed by the Cierres shell.
  "/business/backoffice/usuarios",
];

// React Router matches "/business/backoffice/alertas" and ".../alertas/" as the same route;
// a bare includes() does not. "/" is left alone, since stripping its slash would yield "".
const withoutTrailingSlash = (pathname) =>
  pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;

export const isCierresPath = (pathname) =>
  typeof pathname === "string" &&
  CIERRES_PATHS.includes(withoutTrailingSlash(pathname));
